/*
 *  EqualHeight.js - v1.0.1
 *  https://github.com/JorenVanHee/EqualHeight.js
 *
 *  Made by Joren Van Hee
 *  Under MIT License
 */
!function (a, b) { function c(b, c) { this.elements = b, this.options = a.extend({}, e, c), this._defaults = e, this._name = d, this.active = !1, this.init() } var d = "equalHeight", e = { wait: !1, responsive: !0 }; c.prototype = { init: function () { this.options.wait || this.start(), this.options.responsive && a(b).on("resize", a.proxy(this.onWindowResize, this)) }, magic: function () { var b = 0; this.reset(); for (var c = 0; c < this.elements.length; c++) { var d = a(this.elements[c]).height(); b = d > b ? d : b } if (this.active) { for (var e = 0; e < this.elements.length; e++) { var f = a(this.elements[e]); "table-cell" === f.css("display") ? f.css("height", b) : f.css("min-height", b) } this.active || this.reset() } }, reset: function () { this.elements.css("min-height", ""), this.elements.css("height", "") }, start: function () { this.active = !0, this.magic() }, stop: function () { this.active = !1, this.reset() }, onWindowResize: function () { this.active && this.magic() } }, a.fn[d] = function (a) { return new c(this, a) } }(jQuery, window, document);


// Find and loop over parent containers with class 'equal-cols'
// On Pageload or resize, adjust the heigh of the containers.
$(document).ready(function() {
  $('.equal-cols').each(function() {
    $('.grid__item', this).equalHeight();
  });

  if ($(".template-product").length ) {
    var myVariantText = $(".variant__label-info span").text().trim().replace(/\W/g, "").toUpperCase();
    var myProductText = $(".product-single__title").text().trim().replace(/\W/g, "").toUpperCase();
//     var myVariantText = $(".variant__label-info span").text().trim().replace(/\s/g, "").toUpperCase();
//     var myProductText = $(".product-single__title").text().trim().replace(/\s/g, "").toUpperCase();
    var myTitle = myVariantText ? myVariantText : myProductText;
    
    $(".slick-slide").removeClass("active");
    $(".image-wrap img[data-srcset*='" + myTitle + "']").parents(".slick-slide").addClass("active");
    $(".image-wrap img[data-src*='" + myTitle + "']").parents(".slick-slide").addClass("active");
  }
});


// Thumbnails on products with just one variant aren't showing. This is a fix, but I don't know
// why it's happening. 2020-06-10 EH
$(function(){
  
  let thumbnails = $(".product__thumbs .slick-slide.product__thumb-item");
  
  if (thumbnails.length) {
    
	let active_thumbnails = false;
    
    thumbnails.each(function(i, e){

      // If one thumbnail is active then we aren't on a page where
      // they have all been mysteriously deactivated, and we don't need
      // to do anything.
      if ($(this).hasClass("active")) {
          active_thumbnails = true;
          return;
      }
      
    });

    if (!active_thumbnails) {
      thumbnails.each(function(i, e){
        $(this).addClass("active");
      });
    }
    
  }
  
});


$('div.grid__item > a').hover(
	function() {
		$(this).find('div.image-wrap').fadeTo('slow', 0.33);
	},
    function() {
		$(this).find('div.image-wrap').fadeTo('slow', 1);
	}                       
);
